import React from "react";
import { Integration } from "model/integration";
import { WixCard } from "./card";
import { WixModal } from "./modal";

interface Props {
	integration: Integration;
}

interface State {
	modalOpen: boolean;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = { modalOpen: false };
	}

	public render() {
		const { integration } = this.props;
		const { modalOpen } = this.state;

		return (
			<>
				<WixCard
					integration={integration}
					onViewIntegration={() => this.setState({ modalOpen: true })}
				/>
				<WixModal
					open={modalOpen}
					onClose={() => this.setState({ modalOpen: false })}
					integration={integration}
				/>
			</>
		);
	}

}

export const WixIntegration = Component;
